import _pac from "./ssPoliscript.js";
const pac = _pac;
export default {
  decode: pac.decode,
  encode: pac.encode,
  preProcess: pac.preProcess,
  postProcess: pac.postProcess
};